import React from 'react';
import { H3 } from '../../../../components/typography';

function BulletList() {
    return <H3>Your customers could save money by sharing the family car, with cover from Marmalade</H3>;
}

export default BulletList;
